import { user as api_user } from "../../api/user";
import vuetify from "../../plugins/vuetify";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_PROFILE = "SET_PROFILE";
export const STATUS = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  WELCOME: 'WELCOME',
  FILLING_FORM: 'FILLING_FORM',
  WATCHING_TUTORIAL: 'WATCHING_TUTORIAL',
  READING_CONTRACT: 'READING_CONTRACT',
  DOWNLOADING_CONNECTOR: 'DOWNLOADING_CONNECTOR',
  INSTALLING_CONNECTOR: 'INSTALLING_CONNECTOR',
  INSTALLATION_OK: 'INSTALLATION_OK',
  INSTALLATION_KO: 'INSTALLATION_KO',
  FILLING_PROGRAM_DATA: 'FILLING_PROGRAM_DATA',
  PREPARING_FORMATION: 'PREPARING_FORMATION',
  READY_FOR_FORMATION: 'READY_FOR_FORMATION',
  DOING_TUTORIAL: 'DOING_TUTORIAL',
  TRIAL: 'TRIAL',
  ACTIVE: 'ACTIVE',
  UPDATE_REQUIRED: 'UPDATE_REQUIRED',
  SAGE_BLOCK: 'SAGE_BLOCK',
}
const WELCOME_PROCESS = [
  STATUS.WELCOME,
  STATUS.FILLING_FORM,
  STATUS.WATCHING_TUTORIAL,
  STATUS.READING_CONTRACT,
  STATUS.DOWNLOADING_CONNECTOR,
  STATUS.INSTALLING_CONNECTOR,
  STATUS.INSTALLATION_OK,
  STATUS.INSTALLATION_KO,
  STATUS.FILLING_PROGRAM_DATA,
  STATUS.PREPARING_FORMATION,
  STATUS.READY_FOR_FORMATION,
  STATUS.SAGE_BLOCK
]

import { getField, updateField } from 'vuex-map-fields';
// Types

// models
class Me {
  constructor({ id, username, userData, ..._ }) {
    this.id = id;
    this.username = username;
    // this.email = data["email"];
    this.userData = userData;
  }
}

class Profile {
  constructor() {
    this.form = {
      name: '',
      dni: '',
      email: '',
      bussnies_id: '',
      business_name: '',
      phone: '',
      postal_address: '',
      post_code: '',
      province: '',
      username: '',
      user_role: '',
      receive_newsletter: '',
      installation_notes:'',
      crisp_chat: '',
      a3auto_status: '',
    }
    this.contracts = [];
  }
}

// TODO: workarround until a proper user is fetched
const default_me = new Me({ id: 2, username: "User",  });
const default_profile = new Profile();

const models = {
  Me,
  Profile
};

// initial state
const state = () => ({
  me: default_me,
  profile: default_profile,
  userData: { available_features: {}, enable_invoice_notifications: false }
})


export function getContract(userData) {
  let contract = null;
  for (var i = 0; userData && userData.contracts && i < userData.contracts.length; i++) {
    if (userData.contracts[i].is_vigente) {
      contract = userData.contracts[i];
      break;
    }
  }
  return contract;
}

export function getContractType(userData) {
  let contract = getContract(userData);
  let contractType = (contract) ? contract.contract_type : null;
  return contractType;
}

export function getContractTypeName(userData) {
  let contractType = getContractType(userData);
  let contractTypeName = (contractType) ? contractType.name : null;
  return contractTypeName;
}

// getters

const STAFF_DOC_TYPES=[{id:'in_invoice',text:'Factura de proveedor'},{id:'out_invoice',text:'Factura de cliente'},{id:'payroll',text:'Nómina'}]
const NORMAL_DOC_TYPES=[{id:'in_invoice',text:'Factura de proveedor'},{id:'out_invoice',text:'Factura de cliente'}]
const months = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export const getters = {
  profile: state => state.profile,
  me: state => state.me,
  userData: state => state.userData,
  enable_invoice_notifications: state => state.userData.enable_invoice_notifications,
  useWhiteBrand: state => state.userData.logo != null,
  hastWhiteBrandColor: state => state.userData.white_brand_color != null,
  availableDocs: (state) => {
    var res = state.userData && state.userData.can_see_training_documents ? STAFF_DOC_TYPES: NORMAL_DOC_TYPES;
    if (state.userData.available_features.feature_hide_out_invoice) {
      res.forEach(function (value, i) {
        if (value['id'] == 'out_invoice') {
          res.splice(i, 1);
        }
      });
    }
    return res;
  },
  isWelcomeProcess: state => WELCOME_PROCESS.includes(state.userData.status),
  pendingEmailVerification: state => state.userData.status === STATUS.EMAIL_VERIFICATION,
  inTutorial: state => state.userData.status === STATUS.DOING_TUTORIAL,
  isUpdateProcess: state => state.userData.status === STATUS.UPDATE_REQUIRED,
  docs_num: (state) => {
    let docs_num;
    try {
      let contract = getContract(state.userData);
      docs_num = (contract) ? contract.docs_num.toString() : '';
    } catch {
      docs_num = '';
    }
    return docs_num;
  },
  price: (state) => {
    let price;
    try {
      let contract = getContract(state.userData);
      price = (contract) ? contract.price.toString() : '';
    } catch {
      price = '';
    }
    if (!price && price != '0') {
      try {
        let contractType = getContractType(state.userData);
        price = (contractType) ? contractType.price.toString() : '';
      } catch {
        price = '';
      }
    }
    return price;
  },
  firm_date: (state) => {
    let start_date;
    try  {
      let contract = getContract(state.userData);
      start_date = (contract) ? contract.firm_date : '';
      if (start_date) {
        let dt = start_date.split('-');
        let year = dt[0];
        let month = parseInt(dt[1]);
        let day = dt[2];
        start_date = day + ' de ' + months[month] + ' de ' + year;
      }
    } catch {
      start_date = ''
    }
    return start_date;
  },
  getField,
}

// actions
// const getMe = async ({ commit }) => {
//   // TODO
// };

export function isTrial(userData) {
  let trial = false;
  for (var i = 0; i < userData.contracts.length; i++) {
    if (userData.contracts[i].is_vigente) {
      trial = userData.contracts[i].is_trial;
      break;
    }
  }
  return trial;
}

function isDistributorUser(userData) {
  return userData.sender_docs_user != null && userData.sender_docs_user_distributor_code != null;
}

function shouldHideCrispChat(userData) {
  const features = userData.available_features;
  if (features.feature_force_activate_chat) {
    return false;
  }
  const isClientWithCrispDisabledByOwner = userData.user_role && userData.user_role.value === 'customer' && userData.user_owner && userData.user_owner.feature_disable_crisp_chat_clients;
  return features.feature_disable_crisp_chat ||
         isClientWithCrispDisabledByOwner ||
         isDistributorUser(userData);
}

const forceRefreshUserData = async ({ commit, dispatch, state, rootGetters, rootState }) => {
  let response = await api_user.getUserData({});
  let userData = response.data.results;
  let session_information = rootState['session_information'];
  commit(SET_USER_DATA, { userData });
  commit(SET_PROFILE, userData);
  //----------------------------------------------SHOULD NOT BE HERE------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------------------------------
  let permission = rootGetters["permissions/permission"];
  if (permission && permission.is_readonly && (permission.general.companydb_actividad || permission.general.companydb_actividad.toString() == '0')){
    commit('SET_DEFAULT_ACTIVITY', permission.general.companydb_actividad, { root: true })
  }
  //----------------------------------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------------------------------
  if (userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && session_information.username == userData.username && userData.email) {
    window.execWithCrispReady(() => {
      if (!window.$crisp.get('user:email')) {
        window.$crisp.push(["set", "user:email", userData.email]);
      } else if (window.$crisp.get('user:email') != userData.email) {
        window.$crisp.push(["set", "user:email", userData.email]);
      }

      let sessionDataKey = "session:data";
      let username = userData.username;
      let url = "https://app.inmatic.ai/loginas/";
      let url_user = url + username;
      let sessionData = [
        ['url', url_user],
        ['user', username],
      ];
      if (userData.hasOwnProperty('user_owner')) {
        if (userData.user_owner.version_worker_python) {
          sessionData.push(['version_worker_python', userData.user_owner.version_worker_python]);
        }
        if (userData.user_owner.service_upgrader_version) {
          sessionData.push(['service_upgrader_version', userData.user_owner.service_upgrader_version]);
        }
        if (userData.user_owner.service_version) {
          sessionData.push(['service_version', userData.user_owner.service_version.toString()]);
        }
        if (userData.user_owner.contract_docs) {
          sessionData.push(['contract_docs', userData.user_owner.contract_docs]);
        }
        if (userData.user_owner.contract_banks) {
          sessionData.push(['contract_banks', userData.user_owner.contract_banks]);
        }
        if (userData.user_owner.username) {
          let url_owner = url + userData.user_owner.username;
          sessionData.push(['url_owner', url_owner]);
          sessionData.push(['user_owner', userData.user_owner.username]);
        }
        if (userData.user_owner.phone) {
          sessionData.push(['phone_owner', userData.user_owner.phone]);
        }
        if (userData.user_owner.email) {
          sessionData.push(['email_owner', userData.user_owner.email]);
        }
        if (userData.user_owner.referred_distrib_name) {
          sessionData.push(['referred_distrib_name', userData.user_owner.referred_distrib_name]);
        }
      }

      if (userData.phone) {
        sessionData.push(['phone', userData.phone])
      }

      for (var i = 0; i < sessionData.length; i++) {
        let key = sessionData[i][0];
        if (!window.$crisp.get(sessionDataKey, key) || (window.$crisp.get(sessionDataKey, key) != sessionData[i][1])) {
          window.$crisp.push(["set", sessionDataKey, [sessionData]]);
          break;
        }
      }

      let tags = [];
      if (userData && userData.tags) {
        tags = userData.tags.slice();
      }
      let trial = isTrial(userData);
      if (trial) {
        tags.push('Trial');
      }
      window.$crisp.push(['set', 'session:segments', [tags]]);

    })
  }
  if (shouldHideCrispChat(userData)) {
    window.$crisp.push(["do", "chat:hide"]);
  }
  return response;
};

const refreshUserData = async ({ commit, dispatch, state, rootGetters }) => {
  if(!rootGetters["me/userData"].username){
    let response = await dispatch("forceRefreshUserData");
    return response;
  }
  return false;
};

const setUserData = ({ commit }, userData) => {
  commit(SET_USER_DATA, { userData });
};

const startCrispThread = ({ state }, msg) => {
  try {
    window.$crisp.push(["do", "message:thread:start", [msg]]);
  } catch {}
};

const endCrispThread = ({ state }, msg) => {
  try {
    window.$crisp.push(["do", "message:thread:end", [msg]]);
  } catch {}
};

const hideCrisp = ({ state }) => {
  try {    
    window.$crisp.push(["do", "chat:hide"])
  } catch {}
};

const showCrisp = ({ state }) => {
  try {
    window.$crisp.push(["do", "chat:show"])
  } catch {}
};

const initialInstalationConnector = async ({commit, dispatch, state, rootGetters }) => {
  try {
    const form = {
      status: STATUS.DOWNLOADING_CONNECTOR,
    };
    const response = await api_user.setUserInfo(form);
    dispatch('setUserData', response.data.results);
  } catch {}
};

export const actions = {
  forceRefreshUserData,
  refreshUserData,
  setUserData,
  startCrispThread,
  endCrispThread,
  hideCrisp,
  showCrisp,
  initialInstalationConnector,
}

// mutations
export const mutations = {
  [SET_USER_DATA](state, { userData }) {
    state.userData = {
      ...state.userData,
      ...userData,
      enable_invoice_notifications:
        userData.enable_invoice_notifications !== undefined && userData.enable_invoice_notifications !== null
          ? userData.enable_invoice_notifications
          : state.userData.enable_invoice_notifications !== undefined && state.userData.enable_invoice_notifications !== null
            ? state.userData.enable_invoice_notifications
            : false,
    };

    // Apply personalized Vuetify colors if present
    if (userData.personalized_colors && vuetify.framework && vuetify.framework.theme) {
      Object.keys(userData.personalized_colors).forEach(colorKey => {
        vuetify.framework.theme.themes.light[colorKey] = userData.personalized_colors[colorKey];
      });
    }
  },
  [SET_PROFILE](state, userData) {
    if(state.profile){
      state.profile.form.name = userData.name;
      state.profile.form.email = userData.email;
      state.profile.form.dni = userData.dni;
      state.profile.form.bussnies_id = userData.bussnies_id;
      state.profile.form.business_name = userData.business_name;
      state.profile.form.phone = userData.phone;
      state.profile.form.postal_address = userData.postal_address;
      state.profile.form.post_code = userData.post_code;
      state.profile.form.province = userData.province;
      state.profile.contracts = userData.contracts;
      state.profile.form.username = userData.username;
      state.profile.form.user_role = userData.user_role.name;
      state.profile.form.receive_newsletter = userData.recieve_newsletter;
      state.profile.form.installation_notes = userData.installation_notes;
      state.profile.form.crisp_chat = userData.crisp_chat;
      state.profile.form.a3auto_status = userData.a3auto_status;
    }
  },
  updateField,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  models
}
